import { createInput, createSelect, MountTarget, newDialog, readConfig } from './utils/elements';

export const REKENREEKS_EDIT_SELECTOR = '.cds-lrn-rekenreeks';

interface RekenreeksConfig {
  rows: number;
  termA: string;
  markA: string;
  termB: string;
  markB: string;
  termC: string;
}

export function rekenreeksDialog(
  insertHtml: (html: string) => void,
  mountTarget?: MountTarget,
  existingEl?: HTMLElement
) {
  const dialog = newDialog('Rekenreeks maken', () => insertHtml(''), mountTarget);

  const label = document.createElement('div');
  label.classList.add('label-large');
  label.innerHTML = 'Sjabloon';
  dialog.querySelector('#cds-dialog-content').append(label);

  const container = document.createElement('div');
  container.classList.add('flex', 'gap-2xs', 'items-center');

  const termA = createInput('termLeft', '', 'text', undefined, 70);
  container.append(termA.field);

  const signs = [
    { label: '+', value: '+' },
    { label: '-', value: '-' },
    { label: 'x', value: 'x' },
    { label: ':', value: ':' },
    { label: '=', value: '=' },
  ];
  const markA = createSelect('mark', '', signs, 60);
  container.append(markA.field);

  const termB = createInput('termRight', '', 'text', undefined, 70);
  container.append(termB.field);

  const markB = createSelect('mark', '', signs, 60);
  container.append(markB.field);

  const termC = createInput('result', '', 'text', undefined, 70);
  container.append(termC.field);

  dialog.querySelector('#cds-dialog-content').append(container);

  const rows = createInput('rows', 'Aantal rijen', 'number');
  dialog.querySelector('#cds-dialog-content').append(rows.field);

  if (existingEl) {
    const cfg = readConfig<RekenreeksConfig>(existingEl, { rows: 1, termA: '', markA: '', termB: '', markB: '', termC: '' });
    if (cfg.rows) rows.setValue(cfg.rows);
    if (cfg.termA) termA.setValue(cfg.termA);
    if (cfg.markA) markA.setValue(cfg.markA);
    if (cfg.termB) termB.setValue(cfg.termB);
    if (cfg.markB) markB.setValue(cfg.markB);
    if (cfg.termC) termC.setValue(cfg.termC);
  }

  dialog.addEventListener('onSubmit', () => {
    const config: RekenreeksConfig = {
      rows: +rows.value(),
      termA: termA.value(),
      markA: markA.value(),
      termB: termB.value(),
      markB: markB.value(),
      termC: termC.value(),
    };
    insertHtml(createTable(config));
  });
}


function createTable(config: RekenreeksConfig) {
  const { rows, termA, markA, termB, markB, termC } = config;
  const table = document.createElement('table');
  table.classList.add('cds-lrn-rekenreeks', 'cds-rekenreeks');
  table.setAttribute('data-cb-config', JSON.stringify(config));
  for (let i = 0; i < rows; i++) {
    const row = document.createElement('tr');

    const cellA = document.createElement('td');
    cellA.innerHTML = termA;
    cellA.classList.add('p-ie-3xs', 'p-b-2xs', 'text-right');
    cellA.style.verticalAlign = 'middle';

    const cellMarkA = document.createElement('td');
    cellMarkA.innerHTML = markA;
    cellMarkA.classList.add('p-ie-3xs', 'p-b-2xs', 'text-center');
    cellMarkA.style.verticalAlign = 'middle';

    const cellB = document.createElement('td');
    cellB.innerHTML = termB;
    cellB.classList.add('p-ie-3xs', 'p-b-2xs', 'text-right');
    cellB.style.verticalAlign = 'middle';

    const cellMarkB = document.createElement('td');
    cellMarkB.innerHTML = markB;
    cellMarkB.classList.add('p-ie-3xs', 'p-b-2xs', 'text-center');
    cellMarkB.style.verticalAlign = 'middle';

    const cellC = document.createElement('td');
    cellC.innerHTML = termC;
    cellC.classList.add('p-b-2xs', 'text-left');
    cellC.style.verticalAlign = 'middle';

    row.append(cellA, cellMarkA, cellB, cellMarkB, cellC);
    table.append(row);
  }

  return table.outerHTML;
}
